module.exports = __webpack_public_path__ + "static/media/cursos.74d48a64.svg";